/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Buffer } from 'buffer';

import { createBrowserHistory } from 'history';
import Axios from 'axios';

// project imports
import { ACCESS_TOKEN, REFRESH_TOKEN, setToken, unsetToken, getToken, getPayload, isTokenExpired, setAccessToken, setAppToken } from './token';
import { getBuyerHeaders, getBuyersUrl, getSellerUrl } from 'shared/http';
import { refreshToken, buyerUserDetail, connectToken } from 'shared/settings/apiconfig';
import store from 'features/store';
import moment from 'moment-timezone';
import { setPmSteps } from 'shared/utils/utils';

export async function appLogIn() {
    // TODO: Call the buyer or seller service to validate token and get access token 
    const loginData = {
        "data": {
            "app_identifier": "ctbids_buyer",
            "app_secret": "SGFwcHkgU3VuZEB5IG1lYWxzIHg2QVRPUk5KVlpXZQ=="
        }
    };
    await Axios.post(getSellerUrl(connectToken), JSON.stringify(loginData), getBuyerHeaders(false)).then(response => {
        try {
            setAppToken(response.data);
        } catch (e) {
            console.warn(e);
        }
    }).catch(Error => console.error(Error));
}

/* sets token for the newly logged in user */
export async function login(token, props) {
    // sets the user token in local storage
    setToken(token);

    // call the user api to set user detail in app
    await setUser(null, props.props);
}

/* sets token for the newly logged in user (Promise method) */
export async function loginWithRes(token, props) {
    // sets the user token in local storage
    setToken(token);

    // call the user api to set user detail in app
    return await setUser(null, props.props);

}

/* removes user token on logout or expiry */
export function logout(history, navigate = true, redirect_url = '') {
    // unset user from app
    store.dispatch({ type: 'SET_USER', payload: {} });

    // clears the new access token get call interval
    if (store.getState()['refreshInterval']) {
        clearInterval(store.getState()['refreshInterval']);
    }

    // clears token details from local storage
    unsetToken();
    // getAppToken();
    if (navigate) {
        history.push(redirect_url ? '?' + redirect_url : '/');
    }
}

// async function getAppToken() {
//     await appLogIn();
// }

/* set user details to global state from token payload */
export async function setUser(userId = null, props) {
    try {
        const userFields = ['id', 'firstname', 'lastname', 'url', 'location', 'profilecompleted', 'email', 'paymentcompleted','deleteRequest','active',"deletestatus","membershipCompleted", "interestCompleted","suspensionstatus"];

        if (!userId) {
            const payload = getPayload(ACCESS_TOKEN);
            userId = payload['user'];
            setTokenInterval(payload.exp - payload.iat);
        }
        return await Axios.post(getBuyersUrl(`${buyerUserDetail}/${userId}`), { field: userFields }, getBuyerHeaders())
            .then(response => {
                const paymentCompleted = response.data['data'][0]['paymentcompleted']
                store.dispatch({
                    type: 'SET_USER',
                    payload: {
                        id: response.data['data'][0]['id'],
                        firstName: response.data['data'][0]['firstname'],
                        lastName: response.data['data'][0]['lastname'],
                        profileImage: response.data['data'][0]['url'],
                        roleid: response.data['data'].map(el => el['roleid']),
                        role: response.data['data'].map(el => el['role']),
                        locationid: response.data['data'].map(el => el['locationid']),
                        profilecompleted: response.data['data'][0]['profilecompleted'],
                        deleteRequest: response.data['data'][0]['deleteRequest'],
                        deleteStatus:response.data['data'][0]['deletestatus'],
                        email: response.data['data'][0]['email'],
                        active: response.data['data'][0]['active'],
                        paymentcompleted: paymentCompleted,
                        membershipCompleted: response.data['data'][0]['membershipCompleted'],
                        interestCompleted : response.data['data'][0]['interestCompleted'],
                        suspensionstatus : response.data['data'][0]['suspensionstatus']
                    }
                });
                // store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: false, mode: 'Sign-In' } });
                store.dispatch({ type: 'SET_SIGNIN_FORM_LOADING', payload: false });
                store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: false, extraData: null } });

                // after closing all the modal opens nofification modal (if needed)
                if(props?.toggleSignInModal?.mode == "Sign-In" && props?.location?.pathname == "/" && (response?.data?.['data'][0]['profilecompleted'] == 0 || response?.data?.['data'][0]['paymentcompleted'] == 0)) {
                    store.dispatch({ type: 'TOGGLE_NOTIFICATION_MODAL', payload: { show: true }, navigateData: null }); 
                }  
                
                // Show membership modal
                const saleItemsRegex = /^\/estate-sale\/(\d+)\/item\/(\d+)\/(\b[a-zA-Z0-9 !-@#$%^&*)({}]+)/;
                const saleItems = saleItemsRegex.exec(props?.history?.location?.pathname);

                if(props?.toggleSignInModal?.mode == "Sign-In" && (response?.data?.['data'][0]['profilecompleted'] == 1 && response?.data?.['data'][0]['paymentcompleted'] == 1 && response?.data?.['data'][0]['membershipCompleted'] == 0) && (saleItems || props.history.location.pathname == "/")) {
                    store.dispatch({ type: 'MEMBERSHIP_MODAL', payload: { show: true } }); 
                }  
                return response.data.data[0];
            }).catch(error => {
                logout(null, false);
                return null;
            });
    } catch (error) {
        logout(null, false);
        store.dispatch({ type: 'SET_SIGNIN_FORM_LOADING', payload: false });
        // toast.error('Failed to set user');
        // TODO: Error message handle
    }
}

/* checks where user is authenticated by validating token */
export async function isAuthenticated(history) {
    if (!isTokenExpired(REFRESH_TOKEN)) {
        await tokenRefresh();
        // await getAppToken();
        let userData = await setUser();
        setPmSteps(userData);

    } else {
        if (getToken(REFRESH_TOKEN)) {
            store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
            const encoded = Buffer.from(history.location.pathname).toString("base64");
            await logout(history, true, encoded);
        } else {
            // await appLogIn();
        }
    }
}

/* checks whether a valid token is available */
export function isAuthorized(logoutUser = false) {
    let userLogin = getToken(ACCESS_TOKEN) ? true : false;

    if (logoutUser && userLogin) {
        logout(null, false);
        userLogin = false;
    }

    return userLogin;
}

/* set interval to update access token */
async function setTokenInterval(interval) {
    const intervalId = setInterval(tokenRefresh, (interval - 10) * 1000);
    setRemainingTime((interval - 10) * 1000)
    await store.dispatch({ type: 'SET_REFRESH', payload: intervalId });
}

/* api call to fetch new access token */
async function tokenRefresh() {
    const headers = {
        'Authorization': `Bearer ${getToken(REFRESH_TOKEN)}`,
        'Content-Type': 'application/json'
    };

    await Axios.get(getBuyersUrl(refreshToken), { headers: headers })
        .then(response => {
            setAccessToken(response.data['newToken']);
            // store.dispatch({ type: 'TOGGLE_REFRESH_MODAL', payload: false });
        })
        .catch(error => {
            // toast.error('Failed to set new token');
            // logout(createBrowserHistory());
            // createBrowserHistory().push('/home');
            // store.dispatch({ type: 'TOGGLE_REFRESH_MODAL', payload: true });
        });
}

export async function handleToken() {
    return await tokenRefresh();
}

/**
 * Manual token refresh
 *  
 * @returns Promise
 */
export async function checkRefreshToken() {
    return await isAuthenticated(createBrowserHistory());
}

/**
 * If session expired this will return true otherwise return false
 * 
 * @returns True or False
 */
export function isSessionExpired() {
    return isTokenExpired(REFRESH_TOKEN);
}


export function setRemainingTime(interval) {
    setInterval(() => {

    }, 1000);
}

/**
 * Get token remaining time in minutes.
 * 
 * @returns minutes remaining
 */
export function getRemainingTime(refreshToken = true) {
    const token = refreshToken ? REFRESH_TOKEN : ACCESS_TOKEN;
    try {
        if (isAuthorized()) {
            const payload = getPayload(token);
            const expiration = moment(new Date(payload.exp * 1000));
            const now = moment(new Date());
            var duration = moment.duration(expiration.diff(now));
            var days = parseInt(duration.asMinutes());
            return days;
        }
        return 0;
    } catch (error) {
        return 6;
    }

}